// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:38
import { SagaObject } from '../../SagaBase/SagaObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class FileDescriptor_abstract extends SagaObject {
  static $t: string = 'SagaSchema.FileDescriptor';
  $t: string = 'SagaSchema.FileDescriptor';

  public static GetMembers(): string[] {
    return ['Version', 'Name', 'Url', 'Size', 'Hash', 'Extension', 'MimeType', 'VersionToken'].concat(SagaObject.GetMembers());
  }

  public GetMembers(): string[] {
    return FileDescriptor_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Version: number = 0;
  public Name: string;
  public Url: string;
  public Size: number = 0;
  public Hash: string;
  public Extension: string;
  public MimeType: string;
  public VersionToken: Guid = GuidTools.Empty;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
